import { CapturePhoto } from './capture-photo.js';

CapturePhoto.defineCustomElement();

export { CapturePhoto };
